export const TabType = Object.freeze({
  // 消费总览
  overview: 'overview',
  // 账单
  bill: 'bill',
  // 按量明细
  quantityDetail: 'quantityDetail',
  // 购买效果图会员
  render: 'render',
  // 云制作币消费
  desktop: 'desktop',
})

export const PayStatus = Object.freeze({
  not: 0,
  already: 1,
})

export const payStatusList = [PayStatus.not, PayStatus.already]

export const PayStatusMap = new Map([
  [PayStatus.not, 'user_pay_status_not'],
  [PayStatus.already, 'user_pay_status_already'],
])

export const NodeType = Object.freeze({
  CPU: 0,
  GPU: 1,
  CPU_GPU: 2,
})

export const nodeTypeList = [NodeType.GPU, NodeType.CPU]

export const ConfirmStatusOptions = [
  {
    name: 'unconfirm',
    value: 0,
  },
  {
    name: 'confirm',
    value: 1,
  },
  {
    name: 'auto-confirm',
    value: 2,
  },
]

export const NodeTypeMap = new Map([
  [NodeType.GPU, 'GPU'],
  [NodeType.CPU, 'CPU'],
  [NodeType.CPU_GPU, 'CPU&GPU'],
])

export const FeeType = Object.freeze({
  amount: 0,
  charter: 1,
  member: 3,
})

export const feeTypeList = [FeeType.amount, FeeType.charter, FeeType.member]

export const desktopFeeTypeList = [FeeType.amount, FeeType.charter]

export const FeeTypeMap = new Map([
  [FeeType.amount, 'user_feetype_0'],
  [FeeType.charter, 'user_feetype_1'],
  [FeeType.member, 'user_buy_member'],
])

export const AccountType = Object.freeze({
  main: 1,
  child: 2,
  dingChild: 3,
})

export const AccountTypeMap = new Map([
  [AccountType.main, 'user_accountType_main'],
  [AccountType.child, 'user_accountType_child'],
  [AccountType.dingChild, 'user_accountType_ding_child'],
])

export const SearchType = Object.freeze({
  consumeDate: 'consumeDate',
  consumeMonth: 'consumeMonth',
  billNo: 'billNo',
  userId: 'userId',
  userName: 'userName',
  submitUserName: 'submitUserName',
  userNameAlias: 'userNameAlias',
  userNameOrUserId: 'userNameOrUserId',
  userNameOrUserIdAlias: 'userNameOrUserIdAlias',
  saleManId: 'saleManId',
  platform: 'platform',
  projectName: 'projectName',
  company: 'company',
  payStatus: 'payStatus',
  feeType: 'feeType',
  desktopFeeType: 'desktopFeeType',
  nodeType: 'nodeType',
  confirmStatus: 'confirmStatus',
  taskIds: 'taskIds',
  timeZone: 'timeZone',
  businessType: 'businessType',
  billDetailBusinessType: 'billDetailBusinessType',
})

export const overviewSearch = [
  SearchType.consumeMonth,
  SearchType.userNameOrUserId,
  SearchType.company,
  SearchType.feeType,
  SearchType.nodeType,
  SearchType.businessType,
]

export const billSearch = [
  SearchType.consumeMonth,
  SearchType.billNo,
  SearchType.userNameOrUserId,
  SearchType.payStatus,
  SearchType.confirmStatus,
  SearchType.company,
  SearchType.businessType,
]

export const billDetailSearch = [
  SearchType.timeZone,
  SearchType.consumeDate,
  SearchType.userNameOrUserIdAlias,
  SearchType.submitUserName,
  SearchType.platform,
  SearchType.projectName,
  SearchType.saleManId,
  SearchType.company,
  SearchType.taskIds,
  SearchType.billDetailBusinessType,
]

export const billDetailRenderSearch = [
  SearchType.timeZone,
  SearchType.consumeDate,
  SearchType.userId,
  SearchType.userNameAlias,
  SearchType.platform,
  SearchType.projectName,
  SearchType.saleManId,
  SearchType.company,
]

export const billDetailDesktopSearch = [
  SearchType.consumeDate,
  SearchType.userNameOrUserIdAlias,
  SearchType.platform,
  SearchType.desktopFeeType,
]

export const ExportPermissionMap = new Map([
  [TabType.overview, 'user:consume:month:bill:brief:export'],
  [TabType.quantityDetail, 'user:consume:bill:details:task:export'],
  [TabType.render, 'user:consume:bill:details:member:export'],
  [TabType.desktop, 'user:consume:bill:details:member:export'],
])

export const ConsumeList = Object.freeze({
  consumelist: 0,
  consumeDetail: 1,
})
export const ExportConsumeList = [ConsumeList.consumelist, ConsumeList.consumeDetail]
export const ExportConsumeListMap = new Map([
  [ConsumeList.consumelist, 'user_work_consume_list'],
  [ConsumeList.consumeDetail, 'user_work_consume_detail_list'],
])

export const UserRelateSearch = {UserAccount: 1, UserId: 2}

export const UserRelateSearchOption = [
  {
    label: 'user_username',
    value: UserRelateSearch.UserAccount,
  },
  {
    label: 'user_customer_id',
    value: UserRelateSearch.UserId,
  },
]

export const UserAliasRelateSearchOption = [
  {
    label: 'user_username_alias',
    value: UserRelateSearch.UserAccount,
  },
  {
    label: 'user_deduction_account_id',
    value: UserRelateSearch.UserId,
  },
]

export const AppealStatus = Object.freeze({
  Submitted: 0,
  Handling: 1,
  Finished: 2,
  Reject: 3,
  Withdraw: 4,
})

export const BillListFilter = [
  {text: 'consumption_bill_appeal_status_0', value: AppealStatus.Submitted},
  {text: 'consumption_bill_appeal_status_1', value: AppealStatus.Handling},
  {text: 'consumption_bill_appeal_status_2', value: AppealStatus.Finished},
  {text: 'consumption_bill_appeal_status_3', value: AppealStatus.Reject},
  {text: 'consumption_bill_appeal_status_4', value: AppealStatus.Withdraw},
]
